import { render, staticRenderFns } from "./TypeWriter.vue?vue&type=template&id=3a2a35a0&scoped=true"
import script from "./TypeWriter.vue?vue&type=script&lang=js"
export * from "./TypeWriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a35a0",
  null
  
)

export default component.exports